import React from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FounderSection from "@/components/FounderSection";
import ExpertiseSection from "@/components/ExpertiseSection";
import PublicationsSection from "@/components/PublicationsSection";
import EventsSection from "@/components/EventsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0B1211] relative">
      {/* Background grid */}
      <div className="fixed inset-0 bg-grid pointer-events-none" />
      
      {/* Glow blobs */}
      <div className="glow-blob glow-blob-1" />
      <div className="glow-blob glow-blob-2" />

      <div className="relative z-10">
        <Navbar />
        <HeroSection />
        <div className="section-divider max-w-5xl mx-auto" />
        <FounderSection />
        <div className="section-divider max-w-5xl mx-auto" />
        <ExpertiseSection />
        <div className="section-divider max-w-5xl mx-auto" />
        <PublicationsSection />
        <div className="section-divider max-w-5xl mx-auto" />
        <EventsSection />
        <div className="section-divider max-w-5xl mx-auto" />
        <ContactSection />
        <Footer />
      </div>
    </div>
  );
}
